const appConfig = {
    "API_URL": "https://credit-buy-api.tabbank.com/",
    "API_NAME": "Credit Buy API (production)"
   };

   module.exports = appConfig;